export default "/_next/static/chunks/fonts/Raleway ExtraLight-3608ab904025e06b238d48d26c6c41cd.ttf";